module.exports = __webpack_public_path__ + "static/media/long-arrow-alt-right.4e6db688.svg";